import { Disclosure, Transition } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import { StatsProfil } from "../common/home/Stats";
import ChevronUpIcon from "../../assets/images/icon_profile/chevron.svg";
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import { getFaq } from "../../core/service/api";

const ComponentFAQ = () => {
  const { t } = useTranslation();
  const [faqData, setFaqData] = useState<any>([]);
  let faq = [
    {
      title: t("FAQ.pw"),
      description: t("FAQ.pwdesc"),
    },
    {
      title: t("FAQ.user"),
      description: t("FAQ.userdesc"),
    },
    {
      title: t("FAQ.invoice"),
      description: t("FAQ.invoicedesc"),
    },
    {
      title: t("FAQ.pay"),
      description: t("FAQ.paydesc"),
    },
    {
      title: t("FAQ.topup"),
      description: t("FAQ.topupdesc"),
    },
  ];

  const getDataFaq = () => {
    getFaq("PSPMOBILE", "id", "HOME").then(
      (res) => {
        setFaqData(res.data);
        // console.log(res);
      },
      (err) => {}
    );
  };

  useEffect(() => {
    getDataFaq();
  }, []);
  return (
    <div className="bg-psp-primary font-montserrat pb-20">
      <StatsProfil />
      <div className="relative container w-full z-10 bg-white -mt-20 rounded-xl border px-3 py-2">
        <div className="flex p-2">
          <BackButton />
          <h2 className="font-bold">{t("FAQ.title")}</h2>
        </div>
        <div className="w-full mt-3">
          <div className="w-full rounded-2xl bg-white p-2">
            {faqData.map((res: any) => (
              <Disclosure>
                {({ open }) => (
                  <>
                    <Disclosure.Button
                      className={`${
                        open
                          ? "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-3 text-left font-bold rounded-lg rounded-b-none border-1 border-blue-200"
                          : "bg-white flex w-full justify-between items-center bg-purple-100 px-4 py-3 text-left font-bold rounded-lg "
                      }`}
                    >
                      <span>{res.question}</span>
                      <img
                        src={ChevronUpIcon}
                        className={`${
                          open ? "rotate-180 transform" : ""
                        } h-3 w-3 text-purple-500`}
                      />
                    </Disclosure.Button>
                    <Transition
                      show={open}
                      enter="transition duration-100 ease-out"
                      enterFrom="transform scale-95 opacity-0"
                      enterTo="transform scale-100 opacity-100"
                      leave="transition duration-75 ease-out"
                      leaveFrom="transform scale-100 opacity-100"
                      leaveTo="transform scale-95 opacity-0"
                    >
                      <Disclosure.Panel className="px-4 py-3 font-normal text-black rounded-b-xl bg-blue-50">
                        <span className="text-black font-montserrat">
                          {res.answer}
                        </span>
                        <img hidden={!res.image} src={res.image} />
                      </Disclosure.Panel>
                    </Transition>
                  </>
                )}
              </Disclosure>
            ))}
            {/* <div className="flex relative mt-10 justify-between">
              <div className="pt-2 w-1/4">
                <p>
                  Showing {page + 1} to {size} of {total} entry
                </p>
              </div>
              <div className="w-auto">
                <div className="">
                  <select
                    // onChange={(value) => {
                    //   changeSize(value.target.value);
                    // }}
                    value={size}
                    className="py-2 border rounded-lg bg-white"
                  >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={1000}>1000</option>
                  </select>
                  <span className="ml-1">entries per page</span>
                </div>
              </div>
              <div className="flex w-1/4">
                <button
                  // onClick={() => changePage(page - 1)}
                  disabled={page === 0}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  Previous
                </button>
                <button
                  // onClick={() => changePage(page + 1)}
                  disabled={(page + 1) * size > total}
                  className="disabled:bg-slate-200 disabled:text-slate-400 border mr-2 bg-blue-300 text-blue-600 rounded-md w-36 hover:text-white hover:bg-psp-hover"
                >
                  Next
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComponentFAQ;
